import { render } from "./QuestionsStep.vue?vue&type=template&id=35dbf070"
import script from "./QuestionsStep.vue?vue&type=script&lang=js"
export * from "./QuestionsStep.vue?vue&type=script&lang=js"

import "./QuestionsStep.vue?vue&type=style&index=0&id=35dbf070&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__